import React from 'react'
import { RouteProps } from '../../routes/AppRouter'
import { CreateParticipant as C } from '../../features/users'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import logoCareme from '../../assets/caremeLogoMain.svg'
import style from '../layout/Main.module.css'
import { Box } from '@mui/material'

export function EditParticipant(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()

  setTitle(title)

  return (
    <>
      <C id={props.id} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
